import type { NewClosedProjectsPeriod } from '@models/interfaces';

type NewClosedProjectsSeriesKey = keyof Pick<
  NewClosedProjectsPeriod,
  'closedCount' | 'newCount'
>;

interface NewClosedProjectsSeriesConfig {
  dataKey: NewClosedProjectsSeriesKey;
  fill: string;
  name: string;
}

export const NEW_CLOSED_PROJECTS_CHART_COLORS = {
  closed: '#03ffd2',
  cumulative: '#f2c94c',
  new: '#40a9ff',
};

export const NEW_CLOSED_PROJECTS_AREA_SERIES: NewClosedProjectsSeriesConfig[] =
  [
    {
      dataKey: 'newCount',
      fill: NEW_CLOSED_PROJECTS_CHART_COLORS.new,
      name: 'New Projects',
    },
    {
      dataKey: 'closedCount',
      fill: NEW_CLOSED_PROJECTS_CHART_COLORS.closed,
      name: 'Closed Projects',
    },
  ];

export const hasNewClosedProjectsSeriesData = (
  series: NewClosedProjectsPeriod[],
): boolean => series.length > 0;
